import { combineReducers } from 'redux';
import { all } from 'redux-saga/effects';

import { setUnauthorizedActionType } from './user/actionTypes';
import apiKeyDuck, { $actions as $apiKeyActions } from './apiKey';
import billingDuck, { $actions as $billingActions } from './billing';
import companyDuck, { $actions as $companyActions } from './company';
import contractsDuck, { $actions as $contractsActions } from './contracts';
import documentDuck, { $actions as $documentActions } from './document';
import documentFieldDuck, { $actions as $documentFieldActions } from './documentField';
import documentInteractDuck, {
  $actions as $documentInteractActions,
} from './documentInteract';
import documentSign, { $actions as $documentSignAction } from './documentSign';
import folderDuck, { $actions as $folderActions } from './folders';
import gridDuck, { $actions as $gridActions } from './grid';
import integrationDuck, { $actions as $integrationActions } from './integration';
import metaDuck from './meta';
import requestHistoryDuck, { $actions as $requestHistoryActions } from './requestHistory';
import requisiteDuck, { $actions as $requisiteActions } from './requisite';
import signatureRequestDuck, {
  $actions as $signatureRequestActions,
} from './signatureRequest';
import teamDuck, { $actions as $teamActions } from './team';
import userDuck, { $actions as $userActions } from './user';

const appReducer = combineReducers({
  apiKey: apiKeyDuck.reducer,
  requestHistory: requestHistoryDuck.reducer,
  user: userDuck.reducer,
  document: documentDuck.reducer,
  documentField: documentFieldDuck.reducer,
  documentInteract: documentInteractDuck.reducer,
  company: companyDuck.reducer,
  billing: billingDuck.reducer,
  team: teamDuck.reducer,
  requisite: requisiteDuck.reducer,
  meta: metaDuck.reducer,
  contracts: contractsDuck.reducer,
  folder: folderDuck.reducer,
  grid: gridDuck.reducer,
  signatureRequest: signatureRequestDuck.reducer,
});

export const rootReducer = (state, action) => {
  if (action.type === setUnauthorizedActionType) {
    return appReducer(undefined, action);
  }

  return appReducer(state, action);
};

export const rootActions = {
  requestHistory: requestHistoryDuck.actions,
  apiKey: apiKeyDuck.actions,
  user: userDuck.actions,
  document: documentDuck.actions,
  documentField: documentFieldDuck.actions,
  documentInteract: documentInteractDuck.actions,
  company: companyDuck.actions,
  billing: billingDuck.actions,
  team: teamDuck.actions,
  integration: integrationDuck.actions,
  requisite: requisiteDuck.actions,
  documentSign: documentSign.actions,
  contracts: contractsDuck.actions,
  folder: folderDuck.actions,
  grid: gridDuck.actions,
  signatureRequest: signatureRequestDuck.actions,
};

export const $actions = {
  requestHistory: $requestHistoryActions,
  apiKey: $apiKeyActions,
  user: $userActions,
  document: $documentActions,
  documentField: $documentFieldActions,
  documentInteract: $documentInteractActions,
  company: $companyActions,
  billing: $billingActions,
  team: $teamActions,
  integration: $integrationActions,
  requisite: $requisiteActions,
  documentSign: $documentSignAction,
  contracts: $contractsActions,
  folder: $folderActions,
  grid: $gridActions,
  signatureRequest: $signatureRequestActions,
};

export function* rootSagas() {
  yield all([
    ...requestHistoryDuck.sagas,
    ...apiKeyDuck.sagas,
    ...userDuck.sagas,
    ...documentDuck.sagas,
    ...documentFieldDuck.sagas,
    ...companyDuck.sagas,
    ...billingDuck.sagas,
    ...teamDuck.sagas,
    ...integrationDuck.sagas,
    ...requisiteDuck.sagas,
    ...documentSign.sagas,
    ...contractsDuck.sagas,
    ...folderDuck.sagas,
    ...gridDuck.sagas,
    ...signatureRequestDuck.sagas,
  ]);
}
